const handleDeleteFrequencyFailFormParamFreq = {
  title: 'PERIODICITY CANNOT BE DELETED'
};

export default handleDeleteFrequencyFailFormParamFreq;
